module.exports = __webpack_public_path__ + "img/leftside_1000.6517c598.png";